var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-2",on:{"click":function($event){return _vm.sendEmails()}}},[_c('i',{staticClass:"fa fa-envelope fa-fw mr-2"}),_vm._v(" Enviar emails a los clientes "),(_vm.showLoader)?_c('custom-loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }